import React from 'react';
import { BiCode, BiMobile, BiLinkExternal } from 'react-icons/bi';
import { FaGooglePlay } from 'react-icons/fa';
import lmsImg from '../assets/img/LMS.png';
import flappyBirdImg from '../assets/img/Flappy_bird.jpg';
import qrCodeImg from '../assets/img/QR-Code.png';
import currencyConverterImg from '../assets/img/currenct-converter.jpg';
import weatherImg from '../assets/img/weather.jpg';

import wonderWomenImg from '../assets/img/wonder-women.png';
import dashcodeImg from '../assets/img/dashcode.png';
import safeSipImg from '../assets/img/safesip.png';

const Portfolio = () => {
  const portfolioItems = [
    {
      id: 1,
      title: "Wonder Women – Smart Vending App",
      description: "Hardware-integrated Flutter app that turns smartphones into a cashless remote control for smart vending machines via Bluetooth Low Energy (BLE), featuring Moyasar card payments, digital wallets, and real-time inventory tracking.",
      image: wonderWomenImg,
      icon: BiMobile,
      tech: "Flutter • BLE • Moyasar",
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.wonderwomendev.vendos",
      accentColor: "#ec4899"
    },
    {
      id: 2,
      title: "Dashcode – Mobile AI Coding & LMS",
      description: "Mobile-first coding workspace and learning platform enabling users to write and run code in 10+ languages on their phone, complete with an AI coding assistant, GitHub integration, and in-app subscriptions.",
      image: dashcodeImg,
      icon: BiMobile,
      tech: "Flutter • AI • IAP",
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.mobileprogrammerz.ailms",
      liveUrl: "https://mobileprogrammerz.com/",
      accentColor: "#2563eb"
    },
    {
      id: 3,
      title: "SafeSip – Drink Safety Monitoring App",
      description: "Mobile safety application designed for real-time drink monitoring, featuring active session management, instant status alerts, and customizable user profiles.",
      image: safeSipImg,
      icon: BiMobile,
      tech: "Flutter • Real-Time Monitoring",
      accentColor: "#10b981"
    },
    {
      id: 4,
      title: "QR Code Scanner",
      description: "Mobile application for scanning and generating QR codes with additional features",
      image: qrCodeImg,
      icon: BiMobile,
      tech: "Flutter"
    },
    {
      id: 5,
      title: "Currency Converter",
      description: "Flutter app for real-time currency conversion with multiple currencies",
      image: currencyConverterImg,
      icon: BiMobile,
      tech: "Flutter"
    },
    {
      id: 6,
      title: "Weather App",
      description: "Flutter-based weather application with location-based forecasts",
      image: weatherImg,
      icon: BiMobile,
      tech: "Flutter"
    },
    {
      id: 7,
      title: "Flappy Bird Game",
      description: "Interactive game built using Java and JavaFX with smooth gameplay mechanics",
      image: flappyBirdImg,
      icon: BiCode,
      tech: "Java & JavaFX"
    },
    {
      id: 8,
      title: "Library Management System",
      description: "A comprehensive library management system built with C programming",
      image: lmsImg,
      icon: BiCode,
      tech: "C Programming"
    }
  ];

  const portfolioStyles = {
    section: {
      padding: '70px 0',
      backgroundColor: '#f8f9fa'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    sectionTitle: {
      textAlign: 'center',
      marginBottom: '40px'
    },
    title: {
      fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '15px'
    },
    description: {
      fontSize: 'clamp(0.92rem, 1.8vw, 1.05rem)',
      color: '#6c757d',
      maxWidth: '800px',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
      gap: '24px'
    },
    portfolioItem: {
      backgroundColor: '#fff',
      borderRadius: '16px',
      overflow: 'hidden',
      border: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      maxWidth: '100%'
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      height: '240px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa'
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      transition: 'transform 0.3s ease',
      padding: '10px'
    },
    placeholderBanner: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      padding: '20px',
      textAlign: 'center'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(45deg, rgba(0,0,0,0.7), rgba(0,0,0,0.3))',
      opacity: 0,
      transition: 'opacity 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    techBadge: {
      position: 'absolute',
      top: '12px',
      right: '12px',
      backgroundColor: 'rgba(255,255,255,0.95)',
      color: '#1e293b',
      padding: '4px 10px',
      borderRadius: '20px',
      fontSize: '0.75rem',
      fontWeight: '600',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      maxWidth: 'calc(100% - 24px)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    content: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'space-between'
    },
    itemTitle: {
      fontSize: 'clamp(1.15rem, 2vw, 1.3rem)',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '10px'
    },
    itemDescription: {
      fontSize: 'clamp(0.88rem, 1.4vw, 0.95rem)',
      color: '#6c757d',
      lineHeight: '1.6',
      marginBottom: '16px'
    },
    footerActions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 'auto',
      paddingTop: '12px',
      borderTop: '1px solid #f1f5f9',
      flexWrap: 'wrap',
      gap: '10px'
    },
    linksGroup: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap'
    },
    actionBtn: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '7px 14px',
      borderRadius: '8px',
      fontSize: '0.85rem',
      fontWeight: '600',
      backgroundColor: '#2563eb',
      color: '#fff',
      textDecoration: 'none',
      transition: 'opacity 0.2s ease'
    },
    secondaryBtn: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '7px 14px',
      borderRadius: '8px',
      fontSize: '0.85rem',
      fontWeight: '600',
      backgroundColor: '#f1f5f9',
      color: '#1e293b',
      textDecoration: 'none',
      transition: 'background-color 0.2s ease'
    },
    icon: {
      fontSize: '1.75rem',
      color: '#2563eb',
      padding: '8px',
      backgroundColor: '#f8f9fa',
      borderRadius: '50%'
    }
  };

  return (
    <section id="portfolio" style={portfolioStyles.section}>
      <div style={portfolioStyles.container}>
        <div style={portfolioStyles.sectionTitle}>
          <h2 style={portfolioStyles.title}>Portfolio</h2>
          <p style={portfolioStyles.description}>
            Explore my published production mobile applications on Google Play alongside software engineering projects in Flutter, Java, and C.
          </p>
        </div>

        <div style={portfolioStyles.grid}>
          {portfolioItems.map((item) => (
            <PortfolioItem
              key={item.id}
              item={item}
              styles={portfolioStyles}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const PortfolioItem = ({ item, styles }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const itemStyle = {
    ...styles.portfolioItem,
    transform: isHovered ? 'translateY(-6px)' : 'translateY(0)',
    boxShadow: isHovered
      ? '0 16px 32px rgba(0,0,0,0.1)'
      : '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
  };

  const overlayStyle = {
    ...styles.overlay,
    opacity: isHovered ? 1 : 0
  };

  const imageStyle = {
    ...styles.image,
    transform: isHovered ? 'scale(1.03)' : 'scale(1)'
  };

  return (
    <div
      style={itemStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.imageContainer}>
        {item.image ? (
          <img
            src={item.image}
            alt={item.title}
            style={imageStyle}
            loading="lazy"
          />
        ) : (
          <div
            style={{
              ...styles.placeholderBanner,
              background: `linear-gradient(135deg, ${item.accentColor || '#2563eb'}, #1e293b)`
            }}
          >
            <item.icon style={{ fontSize: '3rem', marginBottom: '10px', color: '#fff' }} />
            <span style={{ fontWeight: '700', fontSize: '1.05rem', letterSpacing: '0.5px' }}>
              {item.title.split('–')[0]}
            </span>
          </div>
        )}
        <div style={overlayStyle}>
          <item.icon style={{ ...styles.icon, backgroundColor: 'rgba(255,255,255,0.9)' }} />
        </div>
        <div style={styles.techBadge}>
          {item.tech}
        </div>
      </div>

      <div style={styles.content}>
        <div>
          <h4 style={styles.itemTitle}>{item.title}</h4>
          <p style={styles.itemDescription}>{item.description}</p>
        </div>

        <div style={styles.footerActions}>
          <div style={styles.linksGroup}>
            {item.playStoreUrl && (
              <a
                href={item.playStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.actionBtn}
              >
                <FaGooglePlay /> Google Play
              </a>
            )}
            {item.liveUrl && (
              <a
                href={item.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.secondaryBtn}
              >
                <BiLinkExternal /> Website
              </a>
            )}
          </div>
          <item.icon style={styles.icon} />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
